/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A3Inputs */

const en_fc_home_faq_a3 = /** @type {(inputs: Fc_Home_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit our Use Online page for browser requirements and access options. A launch button appears when a hosted editor is configured. Otherwise, follow the web-build setup steps or use the desktop download guide.`)
};

/**
* | output |
* | --- |
* | "Visit our Use Online page for browser requirements and access options. A launch button appears when a hosted editor is configured. Otherwise, follow the web-..." |
*
* @param {Fc_Home_Faq_A3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a3 = /** @type {((inputs?: Fc_Home_Faq_A3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a3(inputs)
});
export { fc_home_faq_a3 as "fc.home.faq.a3" }